import { useState } from "react";
import { Learning, LearningContent } from "../service/learningService";

export function useLearningForm(initialLearning?: Learning) {
  const [formData, setFormData] = useState({
    name: initialLearning?.name || '',
    type: initialLearning?.type || 'ARTICLE',
    creatorId: initialLearning?.creatorId || '',
    cover: initialLearning?.cover || '',
    coverType: initialLearning?.coverType || 'IMAGE',
    published: initialLearning?.published || false,
    categoryLearning: initialLearning?.categoryLearning || '',
  });

  const [coverFile, setCoverFile] = useState<File | null>(null);
  const [contents, setContents] = useState<LearningContent[]>([]);

  const handleCoverUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setCoverFile(file);
    const reader = new FileReader();
    reader.onloadend = () => {
      setFormData(prev => ({ ...prev, cover: reader.result as string }));
    };
    reader.readAsDataURL(file);
  };

  return { formData, setFormData, coverFile, setCoverFile, contents, setContents, handleCoverUpload };
}
